import { Button } from '@eventbrite/marmalade';
import { useIntl } from 'react-intl';
import styles from './ShowMoreButton.module.scss';

interface Props {
  onShowMore: () => void;
  isLoadingMore: boolean;
  moreLabel?: string;
  loadingLabel?: string;
}

export function ShowMoreButton({ onShowMore, isLoadingMore, moreLabel, loadingLabel }: Props) {
  const intl = useIntl();
  const resolvedMoreLabel =
    moreLabel ?? intl.formatMessage({ id: 'Show more', defaultMessage: 'Show more' });
  const resolvedLoadingLabel =
    loadingLabel ?? intl.formatMessage({ id: 'Loading...', defaultMessage: 'Loading...' });

  return (
    <div className={styles.wrapper}>
      <Button variant="ghost" type="button" onClick={onShowMore} disabled={isLoadingMore}>
        {isLoadingMore ? resolvedLoadingLabel : resolvedMoreLabel}
      </Button>
    </div>
  );
}
